<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.小美首页管理')}}</span>
      </div>
      <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link
            :underline="false"
            v-if="!isEditMode"
          >
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont" >&#xe618;</i>
              {{$t('message.编辑')}}
            </el-button>
          </el-link>
          
          <el-link
            :underline="false"
            v-if="isEditMode"
          >
            <el-button size="medium" round @click="isEditMode=false; refresh();">
              <i class="iconfont" >&#xe600;</i>
              {{$t('message.取消')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
          >
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont" >&#xe667;</i>
              {{$t('message.刷新')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-if="isEditMode"
          >
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont" >&#xe769;</i>
              {{$t('message.保存')}}
            </el-button>
          </el-link>
        </div>
      </div>
      </div>
      <div class="grid-content subtitle">
        <span>{{$t('message.轮播图管理')}}</span>
      </div>
      <!-- 筛选栏开始 -->
      <div class="grid-content content-margin search-style">
        
        <table class="simpleRow">
          <tr>
            <td>
                <el-link
            :underline="false"
            v-if="isEditMode"
          >
           <el-button size="medium" round @click="createTarget" :disabled="!isEditMode">
                  <i class="iconfont" >&#xe727;</i>
                  {{$t('message.新增')}}
            </el-button>
          </el-link>
            </td>
            <td>
              <span class="simpleLabel">{{$t('message.筛选')}}</span>
            </td>
            <td >
              <el-input
              clearable
              prefix-icon="el-icon-search"
              v-model="search"
              size="small"
              :placeholder="$t('message.输入关键字')"/>
            </td>

          </tr>
        </table>
        <!-- 筛选按钮开始 -->
        <div class="search-button"> 
            <div style="flex:0 0 80px;text-align:right"> </div>
            <div style="display:flex;">
              <el-button type="primary" @click="refresh" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini" icon="el-icon-search">检索</el-button>
              <el-button type="danger"  @click="clear" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini"  icon="el-icon-delete">清除</el-button>
            </div>
        </div>
            <!-- 筛选按钮结束 -->
      </div>
      <!-- 筛选栏结束 -->

      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="filterData"
          stripe
          border
          :height="tableHeight"
          style="width: 100%;">
          <el-table-column
            fixed
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" v-if="!isEditMode" round type="normal" icon="el-icon-zoom-in" @click="editTarget(scope.row, false)"></el-button>
                <el-button size="mini" v-else round type="normal" icon="el-icon-edit" @click="editTarget(scope.row, true)"></el-button>
                <el-button size="mini" :disabled="!isEditMode" round type="normal" icon="el-icon-delete" @click="targetRow = scope.row; deleteDialogVisible = true;"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column  label="轮播图片(750*900)" width="150" align="center">
            <template slot-scope="scope">
                <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
                  <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                  <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                </el-popover>
                <span v-else>{{$t('message.无')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
            sortable
            prop="jumpurl"
            :label="$t('message.跳转链接')"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            sortable
            prop="sort"
            :label="$t('message.排序')"
            width="150"
            >
          </el-table-column>
          <el-table-column
            sortable
            :label="$t('message.是否列表显示')"
            width="150"
            >
            <template slot-scope="scope">
              <span>{{$t(`message.${getBooleanName(scope.row.isshow)}`)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
        <div class="grid-content subtitle">
        <span>{{$t('message.产品说明')}}</span>
      </div>
       <div class="grid-content content-margin">

        <table class="simpleRow">
          <tr>
            <td>
              <el-link
                :underline="false"
              >
                <el-button size="medium" round @click="createTargetprodesc" :disabled="!isEditMode">
                  <i class="iconfont" >&#xe727;</i>
                  {{$t('message.新增')}}
                </el-button>
              </el-link>
            </td>
            <td>
              <span class="simpleLabel">{{$t('message.筛选')}}</span>
            </td>
            <td >
              <el-input
              clearable
              prefix-icon="el-icon-search"
              v-model="search2"
              size="small"
              :placeholder="$t('message.输入关键字')"/>
            </td>

          </tr>
        </table>
      </div>
     <div class="grid-content content-margin">
        <el-table
          :data="filterData2"
          stripe
          border
          >
          <el-table-column
            fixed
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" v-if="!isEditMode" round type="normal" icon="el-icon-zoom-in" @click="editTarget2(scope.row, false)"></el-button>
                <el-button size="mini" v-else round type="normal" icon="el-icon-edit" @click="editTarget2(scope.row, true)"></el-button>
                <el-button size="mini" :disabled="!isEditMode" round type="normal" icon="el-icon-delete" @click="targetRow = scope.row; deleteDialogVisible = true;"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            width="75"
            prop="productid"
            label="产品id"
            show-overflow-tooltip
            >
          </el-table-column>
           <el-table-column
            width="200"
            prop="productid"
            label="产品名"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span v-if="idtoimg[scope.row.productid] != ''" placement="top-start" title="" trigger="hover">
                {{idtoimg[scope.row.productid]}}
                </span>
                <span v-else>{{$t('message.无')}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="产品图片(400*min(240))" min-width="250" align="center">
            <template slot-scope="scope">
                <el-popover v-if="scope.row.img!==null " placement="top-start" title="" trigger="hover">
                  <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                  <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                </el-popover>
                <span v-else>{{$t('message.无')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name1"
            :label="'中文名'"
            width="150"
            >
          </el-table-column>
          <el-table-column
            prop="name2"
            :label="'英文名'"
            width="150"
            >
          </el-table-column>
          <el-table-column
            sortable
            prop="sort"
            :label="$t('message.排序')"
            width="150"
            >
          </el-table-column>
          <el-table-column
            sortable
            :label="$t('message.是否列表显示')"
            width="150"
            >
            <template slot-scope="scope">
              <span>{{$t(`message.${getBooleanName(scope.row.isshow)}`)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="grid-content subtitle">
        <span>{{$t('message.Banner管理')}}</span>
      </div>
      <caroustlist></caroustlist>
      <el-dialog
        :title="$t('message.删除确认')"
        :visible.sync="deleteDialogVisible"
        width="300px"
        :modal="false"
        center
        :before-close="handleClose"
      >
          <i class="iconfont" >&#xe766;</i>
          <span>{{$t('message.请确认是否删除该内容')}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="deleteTarget">{{$t('message.删除')}}</el-button>
          </span>
      </el-dialog>

      <el-drawer
        :show-close="false"
        :size="800"
        :visible.sync="showDateilDrawer"
        :direction="'rtl'"
        :before-close="handleClose">
        <div class="grid-content subtitle">
          <span>{{$t('message.轮播图管理')}}</span>
        </div>
        <div class="grid-content content-margin">
          <div class="buttonarea">
            <el-link
              :underline="false"
            >
              <el-button size="medium" round @click.native="showDateilDrawer = false;">
                <i class="iconfont" >&#xe600;</i>
                {{$t('message.返回')}}
              </el-button>
            </el-link>
            <el-link
              :underline="false"
              v-show="isEditMode"
            >
              <el-button size="medium" round @click="doSaveDetail">
                <i class="iconfont" >&#xe769;</i>
                {{$t('message.确定')}}
              </el-button>
            </el-link>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="grid-content content-margin">
          <table class="simpleRow">
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.图片')}}</span>
              </td>
              <td >

                <!-- 图片库控件 -->
                <div :class="!isEditMode?'unsel-img-box':'sel-img-box'" @click="doShowResourceStore(1)">
                  <i class="iconfont" v-if="!d_img">&#xe727;</i>
                  <el-popover placement="right" trigger="hover" v-else>
                    <img :src="'' + d_img" alt="" style="max-width: 500px;max-height: 500px">
                    <img slot="reference" :src="'' + d_img">
                    <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="d_img = '';"></el-button>
                  </el-popover>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转链接')}}</span>
              </td>
              <td >
                <el-input
                  :readonly="!isEditMode"
                  size="mini"
                  class="linkTextArea"
                  v-model="d_jumpurl"
                  type="textarea"
                  :placeholder="$t('message.请输入链接')"
                  maxlength="2000"
                  show-word-limit
                  width="300px"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转类型')}}</span>
              </td>
              <td >
                <el-select  v-model="jumptype" :placeholder="$t('message.请选择跳转类型')"  :disabled="!isEditMode">
                  <el-option v-for="(it,index) in selectarr" :key="index" :label="it.key" :value="it.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转微信id')}}</span>
              </td>
              <td >
                <el-input size="mini" :disabled="!isEditMode" v-model="jumpwxappid"></el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.是否显示')}}</span>
              </td>
              <td >
                <el-switch
                :disabled="!isEditMode"
                v-model="d_isShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.优先级排序')}}</span>
              </td>
              <td >
                <el-input-number :min="0" :disabled="!isEditMode" size="mini" v-model="d_sort"></el-input-number>
              </td>
            </tr>
            <tr>
              <td>{{$t('message.验证手机号')}}</td>
              <td>
                <el-switch
                :disabled="!isEditMode"
                v-model="isphone"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
            <tr >
              <td>{{$t('message.验证注册信息')}}</td>
              <td>
                <el-switch
                :disabled="!isEditMode"
                v-model="isregiste"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
          </table>
        </div>
      </el-drawer>
      <shade v-if="showResourceStore > 0">
        <resource-store
          :shadeShow="showResourceStore > 0"
          @onClick="onResourceStoreCallback"
          :appID="appid"
        ></resource-store>
      </shade>
      <el-drawer
        :show-close="false"
        :size="800"
        :visible.sync="showDateilDrawer2"
        :direction="'rtl'"
        :before-close="handleClose">
        <div class="grid-content subtitle">
          <span>{{$t('message.产品')}}</span>
        </div>
        <div class="grid-content content-margin">
          <div class="buttonarea">
            <el-link
              :underline="false"
            >
              <el-button size="medium" round @click.native="showDateilDrawer2 = false;">
                <i class="iconfont" >&#xe600;</i>
                {{$t('message.返回')}}
              </el-button>
            </el-link>
            <el-link
              :underline="false"
              v-show="isEditMode"
            >
              <el-button size="medium" round @click="doSaveDetail2">
                <i class="iconfont" >&#xe769;</i>
                {{$t('message.确定')}}
              </el-button>
            </el-link>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="grid-content content-margin">
          <table class="simpleRow">
            <tr>
              <td>
                <span class="simpleLabel">选择产品</span>
              </td>
              <td >

                <!-- 图片库控件 -->
                <div  >
                  <!-- <i class="iconfont" v-if="!idtoimg[d_img]">&#xe727;</i>
                  <span>{{idtoimg[d_img]}}</span> -->
                   <el-button size="mini"  v-if="isEditMode"  @click="showdraw2" >{{idtoimg[d_img]?idtoimg[d_img]:'选择'}}</el-button>
                   <el-button size="mini"  v-else  >{{idtoimg[d_img]?idtoimg[d_img]:'选择'}}</el-button>


                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">显示图片</span>
              </td>
              <td >

                <!-- 图片库控件 -->
                <div :class="!isEditMode?'unsel-img-box':'sel-img-box'" @click="doShowResourceStore(2)">
                  <i class="iconfont" v-if="!d_myimg">&#xe727;</i>
                  <el-popover placement="right" trigger="hover" v-else>
                    <img :src="'' + d_myimg" alt="" style="max-width: 500px;max-height: 500px">
                    <img slot="reference" :src="'' + d_myimg">
                    <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="d_myimg = '';"></el-button>
                  </el-popover>
                </div>
              </td>
            </tr>
             <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转链接')}}</span>
              </td>
              <td >
                <el-input
                  :readonly="!isEditMode"
                  size="mini"
                  class="linkTextArea"
                  v-model="d_jumpurl"
                  type="textarea"
                  :placeholder="$t('message.请输入链接')"
                  maxlength="2000"
                  show-word-limit
                  width="300px"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转类型')}}</span>
              </td>
              <td >
                <el-select  v-model="jumptype" :placeholder="$t('message.请选择跳转类型')"  :disabled="!isEditMode">
                  <el-option v-for="(it,index) in selectarr" :key="index" :label="it.key" :value="it.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.跳转微信id')}}</span>
              </td>
              <td >
                <el-input size="mini" :disabled="!isEditMode" v-model="jumpwxappid"></el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">中文名</span>
              </td>
              <td >
                <el-input size="mini" :disabled="!isEditMode" v-model="name1"></el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">英文名</span>
              </td>
              <td >
                <el-input size="mini" :disabled="!isEditMode" v-model="name2"></el-input>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.是否显示')}}</span>
              </td>
              <td >
                <el-switch
                :disabled="!isEditMode"
                v-model="d_isShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
            <tr>
              <td>
                <span class="simpleLabel">{{$t('message.优先级排序')}}</span>
              </td>
              <td >
                <el-input-number :min="0" :disabled="!isEditMode" size="mini" v-model="d_sort"></el-input-number>
              </td>
            </tr>
            <tr>
              <td>{{$t('message.验证手机号')}}</td>
              <td>
                <el-switch
                :disabled="!isEditMode"
                v-model="isphone"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
            <tr >
              <td>{{$t('message.验证注册信息')}}</td>
              <td>
                <el-switch
                :disabled="!isEditMode"
                v-model="isregiste"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
              </td>
            </tr>
          </table>
        </div>
      </el-drawer>
      <shade v-if="showShelvesStore > 0">
        <shelves-store2
          v-bind:ismulti="mul"
          v-bind:excludeList="tableDatapro"
          :isshow='showShelvesStore'
          :key="timer"
          @onClick="onStoreClick"
          @onClose='showShelvesStore=0;showShelvesStore=false'
        ></shelves-store2>
      </shade>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {topfixfunc} from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shelvesStore2 from "@/components/productStore/shelvesStore2";

import shade from "@/components/shade/shade";
import caroustlist from "@/components/caroustlist/caroustlist";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
import { PopupManager } from 'element-ui/lib/utils/popup'
import Caroustlist from '../../components/caroustlist/caroustlist.vue';

export default {
  name: "HomeEdit",
  components: {
    shade,
    ResourceStore,
    shelvesStore2,
    caroustlist
  },
  data() {
    return {
      mul:false,
      tableDatapro:[],
      timer: "",
      appid: "188",
      isEditMode: false,
      tableHeight: 500,
      tempName: "",
      deleteDialogVisible: false,
      targetRow: null,
      newtargetRow:null,
      tableData: [],
      search: "",
      tableData2: [],
      search2: "",
      showResourceStore: 0,
      showDateilDrawer: false,
      d_img: "",
      d_jumpurl: "",
      d_sort: 0,
      d_isShowSwitch: true,
      isphone:false,
      isregiste:false,
      jumptype:0,
      jumpwxappid:'',
      selectarr: [{ key: '不跳转', value: 0 }, { key: '外部小程序', value: 1 }, { key: '内部页面', value: 2 }, { key: '第三方链接', value: 3 }, { key: '活动页', value: 4 }]
      ,showDateilDrawer2:false,
      showShelvesStore:false,
      mypage:1,
      // 存储产品列表id对应的图片
      idtoimg:{},
      d_myimg:'',
      name1:'',
      name2:'',
    };
  },
  mounted: function () {
    topfixfunc()
    this.getproductlist()
    // this.$nextTick(function () {
    //   if (this.$refs.table.$el !== "undefined")
    //     this.tableHeight =
    //       window.innerHeight - this.$refs.table.$el.offsetTop - 150;

    //   // 监听窗口大小变化
    //   let self = this;
    //   window.onresize = function () {
    //     self.tableHeight =
    //       window.innerHeight - self.$refs.table.$el.offsetTop - 150;
    //   };
    // });
    // console.log(this.tableHeight);
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    clear(){
        this.search='',
        this.sendData.filterConfig.keyword=''
        this.refresh()
      },
    getproductlist(){
      let sendObj= {
        appID: 188,
        filterConfig: {
          keyword: "",
          filterType: 1,
        },
        pageConfig: {
          page: this.mypage,
          pagesize: 100,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        }
      }
      rejecthttp(false,'post',"/manage/product/getproductlist",sendObj,this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            if(doc.data.data.length>0){
              this.mypage++
              doc.data.data.forEach(it => {
                this.$set(this.idtoimg,it.shelvesid,it.name)
              });
              this.getproductlist()
            }
            }
            });
    },

    showdraw2(){
      // PopupManager.zIndex=6000
      this.showShelvesStore=true
    },
    onStoreClick(doc) {
      // PopupManager.zIndex=1888
      this.timer = new Date().getTime();
      console.log(doc,12345678)
      this.showShelvesStore = !this.showShelvesStore;
      if (this.ismulti) {

      } else {
        console.log(doc.sel.shelvesid)
        this.d_img=doc.sel.shelvesid
      }
      console.log(345678)

    },
    refresh() {
      this.$http
        .get("/manage/homeedit/getinfo", {
          params: {
            appid: 188,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            this.tableData = doc.data.data.carousel;
            this.tableData2 = doc.data.data.product;
            if(!this.tableData) this.tableData = [];
            if(!this.tableData2) this.tableData2 = [];
          }
        });
    },
    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
      // if(type)
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        if(this.showResourceStore==1){
        this.d_img = doc.resourceID;

        }
        if(this.showResourceStore==2){
        this.d_myimg = doc.resourceID;

        }

      }
      this.showResourceStore = 0;
    },
    createTargetprodesc(){
      this.showDateilDrawer2=true
      this.targetRow = null;
      this.d_img = "";
      this.d_jumpurl = "";
      this.d_isShowSwitch = true;
      this.isphone=false
      this.isregiste=false
      this.d_sort = 0;
      this.jumptype=0
      this.jumpwxappid=''
    },
    createTarget() {
      //清空值
      this.isEditMode=true
      this.targetRow = null;
      this.d_img = "";
      this.d_jumpurl = "";
      this.d_isShowSwitch = true;
      this.isphone=false
      this.isregiste=false
      this.d_sort = 0;
      this.jumptype=0
      this.jumpwxappid=''

      this.showDateilDrawer = true;
    },
    editTarget(data, edit) {
      this.targetRow = data;
      //赋值
      console.log(data);
      this.d_img = this.targetRow.img;
      this.d_jumpurl = this.targetRow.jumpurl;
      this.d_isShowSwitch = this.targetRow.isshow == 1 ? true : false;
      this.d_sort = this.targetRow.sort;
      this.isphone=this.targetRow.needmobile
      this.isregiste=this.targetRow.needregister
      this.jumptype=this.targetRow.jumptype
      this.jumpwxappid=this.targetRow.jumpwxappid
      this.showDateilDrawer = true;
      this.doSort();
    },
    editTarget2(data, edit) {
      this.newtargetRow = data;
      //赋值
      console.log(data);
      this.d_img = this.newtargetRow.productid;
      this.d_myimg = this.newtargetRow.img;
      this.name1 = this.newtargetRow.name1;
      this.name2 = this.newtargetRow.name2;
      this.d_jumpurl = this.newtargetRow.jumpurl;
      this.d_isShowSwitch = this.newtargetRow.isshow == 1 ? true : false;
      this.d_sort = this.newtargetRow.sort;
      this.isphone=this.newtargetRow.needmobile
      this.isregiste=this.newtargetRow.needregister
      this.jumptype=this.newtargetRow.jumptype
      this.jumpwxappid=this.newtargetRow.jumpwxappid
      this.showDateilDrawer2 = true;
      this.doSort();
    },
    deleteTarget() {
      console.log(this.targetRow);
      let index = this.tableData.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      if(this.targetRow.productid!==undefined){
      this.tableData2.splice(index, 1);
      this.deleteDialogVisible = false;
      return
      }
      this.tableData.splice(index, 1);
      this.deleteDialogVisible = false;
      this.doSort();
    },
    doSort() {
      this.tableData.sort(function(a,b){
                var x=a['sort'];
                var y=b['sort'];
                return ((x<y)?-1:1);
            });
      this.tableData2.sort(function(a,b){
                var x=a['sort'];
                var y=b['sort'];
                return ((x<y)?-1:1);
            });
    },
    doSave() {
      this.doSort();
      let sendObj = {
        appid: this.appid,
        carousel: this.tableData,
        product:this.tableData2
      };
      rejecthttp(true,'post',"/manage/homeedit/setinfo",sendObj,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.isEditMode = false;
            }
            });
    },
    doSaveDetail() {
      if (this.targetRow) {
        this.targetRow.img = this.d_img;
        this.targetRow.jumpurl = this.d_jumpurl;
        this.targetRow.isshow = this.d_isShowSwitch ? 1 : 0;
        this.targetRow.sort = this.d_sort;
        this.targetRow.needmobile=this.isphone
        this.targetRow.needregister=this.isregiste
        this.targetRow.jumptype=this.jumptype
        this.targetRow.jumpwxappid=this.jumpwxappid

      } else {
        let item = {
          img: this.d_img,
          jumpurl: this.d_jumpurl,
          isshow: this.d_isShowSwitch ? 1 : 0,
          sort: this.d_sort,
          needmobile:this.isphone,
        needregister:this.isregiste,
        jumptype:this.jumptype,
        jumpwxappid:this.jumpwxappid
        };
        this.tableData.push(item);
      }
      this.showDateilDrawer = false;
      this.doSort();
    },
     doSaveDetail2() {
      if (this.newtargetRow) {
        this.newtargetRow.productid = this.d_img;
        this.newtargetRow.jumpurl = this.d_jumpurl;
        this.newtargetRow.isshow = this.d_isShowSwitch ? 1 : 0;
        this.newtargetRow.sort = this.d_sort;
        this.newtargetRow.img= this.d_myimg
       this.newtargetRow.name1=this.name1
       this.newtargetRow.name2=this.name2
        this.newtargetRow.needmobile=this.isphone
        this.newtargetRow.needregister=this.isregiste
        this.newtargetRow.jumptype=this.jumptype
        this.newtargetRow.jumpwxappid=this.jumpwxappid

      } else {
        let item = {
          productid: this.d_img,
          name1:this.name1,
          name2:this.name2,
          img:this.d_myimg,
          jumpurl: this.d_jumpurl,
          isshow: this.d_isShowSwitch ? 1 : 0,
          sort: this.d_sort,
          needmobile:this.isphone,
        needregister:this.isregiste,
        jumptype:this.jumptype,
        jumpwxappid:this.jumpwxappid
        };
        this.tableData2.push(item);
      }
      this.showDateilDrawer2 = false;
      this.doSort();
    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            !this.search ||
            data.jumpurl.toLowerCase().includes(this.search.toLowerCase())
        );
      else return [];
    },
    filterData2() {
      if (this.tableData2)
        return this.tableData2.filter(
          (data) =>{
            let c=data.productid+''
            let d=data.name1
            let e=data.name2
           return  !this.search2 ||
            c.includes(this.search2)||d.includes(this.search2)||e.includes(this.search2)
          }

        );
      else return [];
    },
  },
};
</script>

<style scoped>
.el-table /deep/ td {
    user-select: text!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/HomeEdit/HomeEdit.vue